import React from 'react';

function MapRoute({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M12 10.052a2.34 2.34 0 0 0 2.338-2.338A2.34 2.34 0 0 0 12 5.377a2.34 2.34 0 0 0-2.338 2.337A2.34 2.34 0 0 0 12 10.052ZM12 2c3.15 0 5.714 2.525 5.714 5.628 0 3.353-4.631 11.515-5.714 11.515-1.083 0-5.714-8.162-5.714-11.515C6.286 4.525 8.849 2 12 2Zm9.836 19.581a.952.952 0 0 1-.788.419H2.951a.952.952 0 0 1-.884-1.306l1.905-4.762a.953.953 0 0 1 .884-.599h2.095a.952.952 0 0 1 0 1.905h-1.45l-1.143 2.857h15.282l-1.143-2.857h-1.45a.952.952 0 0 1 0-1.905h2.095c.389 0 .74.237.884.599l1.905 4.762a.952.952 0 0 1-.096.887Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default MapRoute;
